import { Directive, ElementRef, OnInit } from '@angular/core';

@Directive({
    selector: '[stringFormatter]',
    standalone: false
})
export class StringformatterDirective {
  constructor(private el: ElementRef) {}
  ngOnInit() {
    var content = this.el.nativeElement.textContent;
    content = content.replace(/<[^>]*>/g, '').trim();
      
    if (content !== null && content.substr(0) === ':') {
      content = content.substr(1);
    }
    content = content.substr(1);
    this.el.nativeElement.textContent = content;
  }
}
